import React, { useState } from 'react';
import ParticleSystem from './components/ParticleSystem';
import ControlsPanel from './components/ControlsPanel';
import GesturePanel from './components/GesturePanel';
import StatusIndicator from './components/StatusIndicator';
import { useHandTracking } from './hooks/useHandTracking';

function App() {
  const [currentTemplate, setCurrentTemplate] = useState('hearts');
  const [currentColor, setCurrentColor] = useState('#ff6b9d');
  const [status, setStatus] = useState({ type: 'connected', text: 'Initializing...' });
  
  const { handScale, isCameraActive } = useHandTracking({ onStatusChange: setStatus });

  return (
    <>
      <ParticleSystem 
        template={currentTemplate} 
        color={currentColor}
        handScale={handScale}
      />
      <ControlsPanel 
        template={currentTemplate}
        color={currentColor}
        onTemplateChange={setCurrentTemplate}
        onColorChange={setCurrentColor}
        isCameraActive={isCameraActive}
      />
      <GesturePanel isCameraActive={isCameraActive} />
      <StatusIndicator status={status} />
    </>
  );
}

export default App;

